import { render } from "./supportProduct.vue?vue&type=template&id=686cb132&scoped=true&ts=true"
import script from "./supportProduct.vue?vue&type=script&lang=ts"
export * from "./supportProduct.vue?vue&type=script&lang=ts"

import "./supportProduct.vue?vue&type=style&index=0&id=686cb132&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686cb132"]])

export default __exports__